import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;
const AXIOS_TIMEOUT=40000;   //40 seconds

export default axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' },
    timeout : AXIOS_TIMEOUT,
    withCredentials: true
});

export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' },
    timeout : AXIOS_TIMEOUT,
    withCredentials: true
});

export const axiosRefresh = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' },
    timeout : AXIOS_TIMEOUT,
    withCredentials: true
});
